module.exports = __webpack_public_path__ + "static/media/previewMedicalData.773ba085.png";